import { mediaSettingsApi } from "@circle-react/api/mediaSettingsApi";
import { useQuery } from "react-query";

export const useMediaSettings = (signedId: string) => {
  const { data: mediaSettings } = useQuery({
    queryKey: ["mediaSettings", signedId],
    queryFn: () => mediaSettingsApi.show(signedId),
    enabled: !!signedId,
  });

  return {
    mediaSettings,
  };
};
